export default class HeroList{
    constructor({ heroes = [], clickHandler }){
        this.heroes = heroes;
        this.onClick = clickHandler;
    }

    render(container){

        container.innerHTML = '';

        if (this.heroes.length === 0){
            container.innerHTML = `
                <div>
                    <h2>Персонажи отсутсвуют</h2>
                </div>
            `;
            return;
        }

        container.innerHTML = `
            <div class="page-header-title">
                <h2>Выбрать персонажа</h2>
            </div>
        `;

        const heroGrid = document.createElement('div');
        heroGrid.className = 'hero-list';

        this.heroes.forEach(hero =>{
            const heroesElement = this.createHeroElement(hero);
            heroGrid.appendChild(heroesElement);
        })

        container.appendChild(heroGrid);
    }

    createHeroElement(hero){
        const element = document.createElement('div');
        element.className = 'hero-item';
        element.setAttribute('data-id', hero.id);
        element.innerHTML = `
            <img src="${hero.image}" 
            alt="${hero.name}" class="hero-item-image">
            <div class="hero-item-name">${hero.name}</div>
        `;
        this.bindEvent(element, hero)
        return element;
    }

    bindEvent(element, hero){
        element.addEventListener('click', async () =>{
            this.onClick(hero.id);
        })
    }
}